<template lang="pug">
  div
    toolbar
    b-container.py-3.py-lg-5
      b-img.mb-4(src="@/assets/ilustrations/learn.png", fluid, style="max-height:300px;", center)
      h3 Aprende a usar Konverza
      p.text-secondary.mb-4 Aquí encontrarás todos los recursos que necesitas para aprender a usar la plataforma Konverza al 100%.
      b-row(align-v="stretch")
        b-col.mb-3(md="6" v-for="(section, index) in filteredSections", :key="index")
          b-card.h-100(style="position:relative;")
            .mb-3
              h5 
                component(:is="section.icon", v-if="section.icon", :class="section.iconClasses")
                span.ml-1 {{ section.name }}
              p.mb-0.text-secondary {{ section.description }}
            div(style="position:absolute;bottom:1rem;right:1.25rem;")
              b-link.card-link.stretched-link(:href="section.link.href", v-if="section.link.href") {{ section.link.title }}
              b-link.card-link.stretched-link(:to="{...section.link, params: {partner_id: getCurrentUser().partner_id} }", v-else-if="section.link.name == 'partner-certifications'") {{ section.link.title }}
              b-link.card-link.stretched-link(:to="section.link", v-else-if="section.link.name") {{ section.link.title }}
</template>

<script>
import Toolbar from '@/components/Toolbar.vue'
export default {
  components: {
    Toolbar
  },
  computed: {
    isPartner () {
      return (new RegExp('^konverza-partner', 'i')).test(this.getCurrentUser().role_type)
    },
    filteredSections () {
      return this.sections.filter(s => s.name != 'Certifícate' ? true : this.isPartner)
    }
  },
  data () {
    return {
      sections: [
        {
          name: 'Videos tutoriales',
          description: 'Accede a videos tutoriales sobre el uso de la plataforma.',
          link: {name: 'Learn Videos', title: 'Ir a videos'}
        },
        {
          icon: 'award-icon',
          iconClasses: ['text-warning'],
          name: 'Certifícate',
          description: 'A nuestros Partners y Aliados certificados les asignamos clientes que buscan ayuda con su Chatbot y también ganas comisión.',
          link: {name: 'partner-certifications', title: 'Más información'}
        },
        {
          name: 'Konverza Aliados',
          description: 'Aprende cómo puedes incrementar tus ingresos vendiendo Konverza con nuestro programa de Aliados y Partners ideal si eres una agencia o vendedor independiente.',
          link: {href: 'https://konverza.me/partners', title: 'Más información'}
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>

</style>